module.exports = __webpack_public_path__ + "static/media/storyLocked.d49378d5.png";